import gql from 'graphql-tag'

export default gql`
    query adminInsightResult($UserID: String!, $InsightID: String!) {
        adminInsightResult(UserID: $UserID, InsightID: $InsightID)
    }
`
